export function isDocumentNode(object) {
    return object.kind !== undefined;
}
//# sourceMappingURL=isDocumentNode.js.map